import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { Whitelist, WhitelistService } from '../whitelist/whitelist.service';
import { Workspace, WorkspaceService } from '../workspace/workspace.service';
import { WsLimit, WsLimitService } from '../wslimit/wslimit.service';
import { WsSettingList, WsSettingDialogService } from './wssettingDialog.service';

import { Auth } from '../../auth.service';
import { Fmt } from '../../fmt.service';

@Component({
    selector: 'wssetting-dialog',
    templateUrl: './wssettingDialog.component.html',
    styleUrls: ['./../app/app.component.css'],
    providers: [
        Fmt,
        WsSettingDialogService,
        WhitelistService,
    ],
})
export class WsSettingDialogComponent implements OnInit {
    @Output('loadData')
    loadData: EventEmitter<any> = new EventEmitter();

    @Output('newWID')
    newWID: EventEmitter<String> = new EventEmitter();

    public workspacePlans: string[];
    public whitelists: any[];
    public publicUrlWhitelists: any[];
    public ipAddrLists: Array<any>;
    public wsEnableIpfilter: boolean = false;
    public projectLists: {
        display_id: string;
        name: { en: string; ja: string };
        p_id: string;
        script_vars: { [k: string]: string | boolean }[];
        use_cms_mode: boolean;
        w_id: string;
    }[];

    public currentEditWorkspace: Workspace = <Workspace> {};
    public currentEditColumn: TableColumn = <TableColumn> {};
    public currentWsLimit: WsLimit = <WsLimit> {};
    public currentEditKey: string = '';
    public defaultSettingsModal: boolean = false;
    public createWorkspaceModal: boolean = false;
    public defaultRowSettingsModal: boolean = false;
    public workspace: any = '';

    public defaultSettingsForm: FormGroup;
    public createWorkspaceForm: FormGroup;
    public wsSettingsForm: FormGroup = <FormGroup> {};
    public rowSettingsForm: FormGroup = <FormGroup> {};

    public wsFunctions: FunctionsCheckBox[] = [];
    public wsFunctionsSelect: FunctionsCheckBoxSelect[] = [];
    public appFunctions: FunctionsCheckBox[] = [];

    public tableMode: string = 'view';
    public tableModeIpAddr: string = 'view';
    public publicUrlColumns: Array<any> = [
        // {name: 'id', key: 'id', editable: false},
        { name: 'Admin Token', key: 'admin_token', editable: true },
        { name: 'url', key: 'url', editable: true },
        { name: 'method', key: 'method', editable: true },
    ];
    public allowMethods: Array<any> = [
        { value: 'GET', label: 'GET' },
        { value: 'POST', label: 'POST' },
    ];

    public publicIPAddrColumns: Array<any> = [
        // {name: 'id', key: 'id', editable: false},
        { name: 'ip_addr', key: 'ip_addr', editable: true },
    ];

    public projectObj: string | null = null;
    public cmsOption: { label: string; value: boolean; checked?: boolean }[] = [
        { label: 'CMSとして使用する', value: false },
    ];

    constructor(
        private _wsusageService: WsSettingDialogService,
        public _whiteListService: WhitelistService,
        public _fmt: Fmt,
        private fb: FormBuilder,
    ) {}

    ngOnInit(): void {
        this.utilsBuildColSettings('defaultSettingsForm', this.wsLimitColumns);
        this.utilsBuildColSettings('createWorkspaceForm', this.planColumns);
        this.utilsBuildColSettings('rowSettingsForm', this.newEditableRow(`_limit`));
    }

    public tableColumns: TableColumn[] = [
        { name: 'ワークスペース名', key: 'name', editable: false },
        { name: 'ワークスペース管理者', key: 'workspace_admin', editable: false },
        { name: 'ユーザー数', key: 'users', editable: true },
        { name: 'データストア数', key: 'datastores', editable: true },
        { name: 'アイテム数', key: 'items', editable: true },
        { name: 'ストレージ容量 (MB)', key: 'storage', editable: true },
        { name: 'ステータス', key: 'status', editable: false, status: true },
    ];

    public wsLimitColumns: string[] = ['users', 'datastores', 'storage', 'items'];
    public planColumns: string[] = ['name', 'plan_id'];

    private utilsBuildColSettings = (targetForm: string, cols: Array<string>, preloadVal?: any) => {
        var targetCol = {};
        for (const key of cols) {
            targetCol[key] = [preloadVal ? preloadVal[key] : null, [Validators.required]];
        }
        this[targetForm] = this.fb.group(targetCol);
    };

    public editableRowCols = ['users', 'datastores', 'storage', 'items'];

    public newEditableRow = (suffix: string) => this.tableColumns.map(item => `${item.key}${suffix}`);

    ToEditColumn(workspace: Workspace, column: TableColumn, key: string) {
        this.defaultRowSettingsModal = !this.defaultRowSettingsModal;
        this.currentEditWorkspace = workspace;
        this.currentEditColumn = column;
        this.currentEditKey = key;

        this.workspace = workspace;

        if (!this.workspace.ws_functions) {
            this.workspace.ws_functions = {
                ws_settings: {
                    disable_change_name: true,
                    disable_change_logo: true,
                    disable_manage_admins: true,
                    enable_manage_group_admins: false,
                    disable_archive: true,
                    disable_password_policy: true,
                    disable_global_search: true,
                    enable_2fa_login: true,
                    validity_period_2fa: 30,
                    enable_whitelist_url: false,
                    ease_setting_restrictions: false,
                    enable_field_role_validation: false,
                    enable_check_user_limit_flag: false,
                    enable_check_datastore_limit_flag: false,
                    enable_return_timeout_error: false,
                },
                group_settings: {
                    disable_new_group: true,
                    disable_group_import: true,
                    disable_user_import: true,
                    disable_group_roles: true,
                    disable_get_user_list_for_non_admin: true,
                    disable_get_role_users_for_non_admin: true,
                },
                developer_functions: {
                    disable_developer_mode: true,
                    disable_beta: true,
                    disable_generate_token: true,
                    show_access_keys: 2, // 0:none, 1: admin, 2: all
                },
                task_queue: {
                    show_task_list: 2, // 0:none, 1: admin, 2: all
                },
                new_workspaces: {
                    new_workspace: 2, // 0:none, 1: admin, 2: all
                },
                user_settings: {
                    number_bulk_registrations: 0,
                },
                rate_limit: {
                    requests_per_seconds: 0,
                },
            };
        }

        if (!this.workspace.app_functions) {
            this.workspace.app_functions = {
                app_settings: {
                    disable_change_name: true,
                    disable_role_settings: true,
                    disable_left_menu_extension: true,
                    disable_program_extension: true,
                    disable_delete_application: true,
                    skip_access_control: false,
                },
                app_templates: {
                    disable_new_application: true,
                    disable_save_templates: true,
                },
                dashboards: {
                    disable_edit_dashboards: true, // 新規ダッシュボードの作成・編集・削除
                    disable_edit_dash_items: true, // 新規ダッシュボードItemの作成・編集・削除
                },
                data_reports: {
                    disable_edit_reports: true, // 新規データレポートの作成・編集・削除
                    disable_save_reports: true, // データレポートの保存（into Database）
                    disable_csv_downloads: true, // CSVダウンロード
                    disable_grouping_duplicate_datalinks: true, // 内部結合時のアイテム重複グルーピング処理を無効化する
                },
                datastores: {
                    disable_db_settings: true, // Databaseの設定ボタン
                    disable_grid_view: true, // グリッド入力　※apiKv.yml が trueのとき、設定可
                    disable_borad_view: true, // ボードビュー　※apiKv.yml が trueのとき、設定可
                    disable_status_update: true, // ステータスの直接編集　※apiKv.yml が trueのとき、設定可
                    disable_query: true, // よく使う一覧の利用　（左メニュー、左メニューカスタマイズ、保存ボタン等）
                    disable_auto_link: true, // 自動リンクの利用（web-uiでデータリンクキー関連の設定が表示される）
                },
                csv_import: { // CSVインポート
                    disable_csv_update: true, // インポートの利用
                    disable_replace_import: true, // 削除してインポートの利用
                    use_qr_download: false, // CSVダウンロード時、QRコード用データを含める
                },
                item_view: { // Item詳細
                    disable_pagination: true, // 一覧のページ遷移を制限（Freeプラン向け）
                    disable_change_layouts: true, // レイアウトの変更
                    disable_edit_statuses: true, // ステータスの設定
                    disable_edit_fields: true, // フィールドの追加、変更
                    disable_edit_actions: true, // アクションの追加、編集
                    hide_link_items: true, // 関連タブの表示
                    disable_pin_items: true, // ホーム画面へピンどめ
                },
                data_link: {
                    always_update_auto_link: false,
                },
                item_operation: {
                    enable_strictly_validation: false, // 新規アイテムの作成・更新・削除時にアクセス権限チェックを厳密に行う
                    enable_remove_deleted_field: false,
                },
            };
        }

        if (!this.workspace.keycloak_settings) {
            this.workspace.keycloak_settings = {
                host: '',
                realms: [],
            };
        }

        this.getWhiteList();
        this.getWsFunctions();
        this.getAppFunctions();

        this.utilsBuildColSettings('rowSettingsForm', this.newEditableRow(`_limit`), this.currentEditWorkspace);
    }

    fetchModalData(wsID: any) {
        if (wsID) {
            this.fetchURLWhitelists(wsID);
            this.fetchIPAddrWhitelists(wsID);
            this.fetchProjectList(wsID);
        }
    }

    getWhiteList() {
        this._whiteListService.LoadWhitelists<Array<any>>().subscribe(whitelist => {
            this.workspace.admin_users.map(admin => {
                Object.keys(whitelist).forEach(function(key) {
                    if (admin.user_id == whitelist[key].u_id) {
                        admin.is_sv = true;
                        whitelist[key].checked = true;
                    }
                });
            });
            this.whitelists = whitelist;
            this.changeWsAdmin();
        });
    }

    getWsFunctions() {
        this.wsFunctions = [
            { name: 'ワークスペースの管理', key: 'ws_settings', level: 0 },
            { name: 'ロゴの変更', key: 'disable_change_logo', checked: true, level: 1 },
            { name: 'ワークスペース名の変更', key: 'disable_change_name', checked: true, level: 1 },
            { name: 'ワークスペース管理者の登録', key: 'disable_manage_admins', checked: true, level: 1 },
            { name: 'グループ管理者の登録', key: 'enable_manage_group_admins', checked: true, level: 1 },
            { name: 'ワークスペースのアーカイブ', key: 'disable_archive', checked: true, level: 1 },
            { name: 'パスワードポリシーの利用', key: 'disable_password_policy', checked: true, level: 1 },
            { name: '全文検索バー', key: 'disable_global_search', checked: true, level: 1 },
            { name: '2段階認証ログインの利用', key: 'enable_2fa_login', checked: true, level: 1 },
            { name: '2段階認証有効期間', key: 'validity_period_2fa', type: 'number', value: 30, level: 1, nzSpan: 9, note: '※単位は分' },
            { name: '公開URLリストの利用', key: 'enable_whitelist_url', checked: true, level: 1 },
            { name: '自動化BOT設定の制限緩和', key: 'ease_setting_restrictions', checked: false, level: 1 },
            { name: 'アイテム取得時にフィールドロールの権限をチェックする', key: 'enable_field_role_validation', checked: false, level: 1 },
            { name: 'ユーザー登録上限数チェックフラグの有効化', key: 'enable_check_user_limit_flag', checked: false, level: 1 },
            { name: 'データストア登録上限チェックの有効化', key: 'enable_check_datastore_limit_flag', checked: false, level: 1 },
            { name: 'タイムアウト時にエラーを返す', key: 'enable_return_timeout_error', checked: false, level: 1 },
            { name: 'グループの設定', key: 'group_settings', level: 0 },
            { name: '新規グループの追加', key: 'disable_new_group', checked: true, level: 1 },
            { name: 'グループのCSVインポート、エクスポート', key: 'disable_group_import', checked: true, level: 1 },
            { name: 'グループへのロール追加', key: 'disable_group_roles', checked: true, level: 1 },
            { name: 'ユーザーのCSVインポート、エクスポート', key: 'disable_user_import', checked: true, level: 1 },
            { name: 'ワークスペースの管理者やグループの管理者だけユーザー一覧情報を取得可能', key: 'disable_get_user_list_for_non_admin', checked: true, level: 1 },
            { name: 'ワークスペース管理者とグループ管理者のみがロール ユーザーの情報を取得できます。', key: 'disable_get_role_users_for_non_admin', checked: true, level: 1 },
            { name: '開発者向け機能', key: 'developer_functions', level: 0 },
            { name: '開発者向け機能の利用', key: 'disable_developer_mode', checked: true, level: 1 },
            { name: 'ベータ版機能の利用', key: 'disable_beta', checked: true, level: 1 },
            { name: '永続APIトークンの発行', key: 'disable_generate_token', checked: true, level: 1 },
            { name: 'アクセスキーの表示', key: 'show_access_keys', selected: 2, level: 1 },
            { name: 'タスク管理', key: 'task_queue', level: 0 },
            { name: 'タスク情報', key: 'show_task_list', selected: 0, level: 1 },
            { name: 'ワークスペースの作成', key: 'new_workspaces', level: 0 },
            { name: '別ワークスペースの作成', key: 'new_workspace', selected: 2, level: 1 },
            { name: 'ユーザー登録', key: 'user_settings', selected: 0, level: 0 },
            { name: 'APIによる一括登録上限数', key: 'number_bulk_registrations', type: 'number', value: 0, level: 1, nzSpan: 9, note: '※0が設定されている場合はデフォルト数が適用されます。' },
            { name: 'レートリミット(リミットに達するとエラーをレスポンス)', key: 'rate_limit', selected: 0, level: 0 },
            { name: 'リクエスト数/10秒', key: 'requests_per_seconds', type: 'number', value: 0, level: 1, nzSpan: 9, note: '※0が設定されている場合はデフォルト数が適用されます。' },
            { name: 'Keycloak連携', key: 'keycloak_settings', level: 0 },
            { name: 'host設定', key: 'host', type: 'string', level: 1, note: '※https://から始まるkeycloakのhostを設定' },
            { name: 'realm設定', key: 'realms', type: 'keycloak', level: 1 },
        ];

        this.wsFunctionsSelect = [
            { id: 2, name: 'すべてのユーザーに表示' },
            { id: 1, name: '管理者のみ表示' },
            { id: 0, name: 'すべてのユーザーに表示しない' },
        ];

        this.wsFunctions.map(item => {
            switch (item.key) {
                case 'disable_change_name':
                case 'disable_change_logo':
                case 'disable_manage_admins':
                case 'disable_archive':
                case 'disable_password_policy':
                case 'disable_global_search':
                    item.checked = !this.workspace.ws_functions.ws_settings[item.key];
                    break;

                case 'enable_manage_group_admins':
                case 'enable_2fa_login':
                case 'enable_whitelist_url':
                    item.checked = this.workspace.ws_functions.ws_settings[item.key];
                    break;
                case 'ease_setting_restrictions':
                    item.checked = this.workspace.ws_functions.ws_settings[item.key];
                    break;
                case 'enable_field_role_validation':
                    item.checked = this.workspace.ws_functions.ws_settings[item.key];
                    break;
                case 'enable_check_user_limit_flag':
                    item.checked = this.workspace.ws_functions.ws_settings[item.key];
                    break;
                case 'enable_check_datastore_limit_flag':
                    item.checked = this.workspace.ws_functions.ws_settings[item.key];
                    break;
                case 'enable_return_timeout_error':
                    item.checked = this.workspace.ws_functions.ws_settings[item.key];
                    break;
                case 'disable_new_group':
                case 'disable_group_import':
                case 'disable_user_import':
                case 'disable_group_roles':
                    item.checked = !this.workspace.ws_functions.group_settings[item.key];
                    break;
                case 'disable_get_user_list_for_non_admin':
                    item.checked = this.workspace.ws_functions.group_settings[item.key];
                    break;
                case 'disable_get_role_users_for_non_admin':
                    item.checked = this.workspace.ws_functions.group_settings[item.key];
                    break;

                case 'disable_developer_mode':
                case 'disable_beta':
                case 'disable_generate_token':
                    item.checked = !this.workspace.ws_functions.developer_functions[item.key];
                    break;

                case 'show_access_keys':
                    item.selected = this.workspace.ws_functions.developer_functions[item.key];
                    break;

                case 'show_task_list':
                    item.selected = this.workspace.ws_functions.task_queue[item.key];
                    break;

                case 'new_workspace':
                    item.selected = this.workspace.ws_functions.new_workspaces[item.key];
                    break;

                case 'number_bulk_registrations':
                    if (this.workspace.ws_functions.user_settings && this.workspace.ws_functions.user_settings[item.key]) {
                        item.value = this.workspace.ws_functions.user_settings[item.key];
                    } else {
                        item.value = 0;
                    }
                    break;
                case 'requests_per_seconds':
                    if (this.workspace.ws_functions.rate_limit && this.workspace.ws_functions.rate_limit[item.key]) {
                        item.value = this.workspace.ws_functions.rate_limit[item.key];
                    } else {
                        item.value = 0;
                    }
                    break;
                case 'validity_period_2fa':
                    if (this.workspace.ws_functions.ws_settings && this.workspace.ws_functions.ws_settings[item.key]) {
                        item.value = this.workspace.ws_functions.ws_settings[item.key];
                    } else {
                        item.value = 30;
                    }
                    break;
                case 'host':
                    if (this.workspace.keycloak_settings && this.workspace.keycloak_settings[item.key]) {
                        item.value = this.workspace.keycloak_settings[item.key];
                    }
                    break;
                case 'realms':
                    if (this.workspace.keycloak_settings && this.workspace.keycloak_settings[item.key]) {
                        item.value = this.workspace.keycloak_settings[item.key];
                    } else {
                        item.value = [];
                    }
                    break;
            }
        });
    }

    getAppFunctions() {
        this.appFunctions = [
            { name: 'アプリケーションの設定', key: 'app_settings', level: 0 },
            { name: 'アプリケーション名の変更', key: 'disable_change_name', checked: true, level: 1 },
            { name: 'ロールとユーザーの設定', key: 'disable_role_settings', checked: true, level: 1 },
            { name: '左メニューのカスタマイズ', key: 'disable_left_menu_extension', checked: true, level: 1 },
            { name: 'プログラム拡張', key: 'disable_program_extension', checked: true, level: 1 },
            { name: 'アプリケーションの削除', key: 'disable_delete_application', checked: true, level: 1 },
            { name: 'ActionIDの権限チェック', key: 'enable_action_validation', checked: true, level: 1 },
            { name: 'ActionFieldのバリデーションチェック', key: 'enable_field_values_validation', checked: true, level: 1 },
            { name: '権限チェックとアクセスキー取得をスキップする(高速化されますが権限チェックが行われません)', key: 'skip_access_control', checked: true, level: 1 },
            { name: 'アプリケーションの作成と保存', key: 'app_templates', level: 0 },
            { name: '新規アプリケーションの作成', key: 'disable_new_application', checked: true, level: 1 },
            { name: 'テンプレート保存', key: 'disable_save_templates', checked: true, level: 1 },
            { name: 'ダッシュボード', key: 'dashboards', level: 0 },
            { name: '新規ダッシュボードの作成・編集・削除', key: 'disable_edit_dashboards', checked: true, level: 1 },
            { name: '新規ダッシュボードItemの作成・編集・削除', key: 'disable_edit_dash_items', checked: true, level: 1 },
            { name: 'データレポート', key: 'data_reports', level: 0 },
            { name: '新規データレポートの作成・編集・削除', key: 'disable_edit_reports', checked: true, level: 1 },
            { name: 'データレポートの保存', key: 'disable_save_reports', checked: true, level: 1 },
            { name: 'CSVダウンロード', key: 'disable_csv_downloads', checked: true, level: 1 },
            { name: '重複したデータリンクのグルーピング処理を行わない（下位互換維持のため）', key: 'disable_grouping_duplicate_datalinks', checked: true, level: 1 },
            { name: 'データベース', key: 'datastores', level: 0 },
            { name: 'データベースの設定ボタン', key: 'disable_db_settings', checked: true, level: 1 },
            { name: 'グリッド入力', key: 'disable_grid_view', checked: true, level: 1 },
            { name: 'ボードビュー', key: 'disable_borad_view', checked: true, level: 1 },
            { name: 'ステータスの直接編集', key: 'disable_status_update', checked: true, level: 1 },
            { name: 'よく使う一覧の利用　（左メニュー、左メニューカスタマイズ、保存ボタン等）', key: 'disable_query', checked: true, level: 1 },
            { name: '自動リンクの利用　（web-uiでデータリンクキー設定を可能とする）', key: 'disable_auto_link', checked: true, level: 1 },
            { name: 'CSVインポート', key: 'csv_import', level: 0 },
            { name: 'インポートの利用', key: 'disable_csv_update', checked: true, level: 1 },
            { name: '削除してインポートの利用', key: 'disable_replace_import', checked: true, level: 1 },
            { name: 'CSVダウンロード時にQRコードデータを含む機能を利用しない', key: 'use_qr_download', checked: false, level: 1 },
            { name: '洗い替えまたは追加登録時に、アクションスクリプトの実行対象をインポートしたアイテムのみとする', key: 'disable_execute_bulk_action_script', checked: true, level: 1 },
            { name: 'アイテムの詳細', key: 'item_view', level: 0 },
            { name: '一覧のページ遷移を制限（Freeプラン向け）', key: 'disable_pagination', checked: true, level: 1 },
            { name: 'レイアウトの変更', key: 'disable_change_layouts', checked: true, level: 1 },
            { name: 'ステータスの設定', key: 'disable_edit_statuses', checked: true, level: 1 },
            { name: 'フィールドの追加、変更', key: 'disable_edit_fields', checked: true, level: 1 },
            { name: 'アクションの追加、編集', key: 'disable_edit_actions', checked: true, level: 1 },
            { name: '関連タブの表示', key: 'hide_link_items', checked: true, level: 1 },
            { name: 'ホーム画面へピンどめ', key: 'disable_pin_items', checked: true, level: 1 },
            { name: 'アイテムの操作', key: 'item_operation', level: 0 },
            { name: '新規アイテムの作成・更新・削除時にアクセス権限チェックを厳密に行う（下位互換維持のため）', key: 'enable_strictly_validation', checked: false, level: 1 },
            { name: '削除されたフィールドをレスポンスに含めない', key: 'enable_remove_deleted_field', checked: false, level: 1 },
            { name: 'データリンク', key: 'data_link', level: 0 },
            { name: 'ラベル項目以外のアイテム登録・更新で常に自動リンクを更新する', key: 'always_update_auto_link', checked: false, level: 1 },
            { name: 'UploadFileで不要なd_idなどを無視する', key: 'enable_upload_file_validation', checked: true, level: 1 },
        ];

        this.appFunctions.map(item => {
            switch (item.key) {
                case 'disable_change_name':
                case 'disable_role_settings':
                case 'disable_left_menu_extension':
                case 'disable_program_extension':
                case 'disable_delete_application':
                    item.checked = !this.workspace.app_functions.app_settings[item.key];
                    break;
                case 'enable_action_validation':
                case 'enable_field_values_validation':
                case 'enable_upload_file_validation':
                    item.checked = this.workspace.app_functions.app_settings[item.key];
                    break;
                case 'disable_new_application':
                case 'disable_save_templates':
                    item.checked = !this.workspace.app_functions.app_templates[item.key];
                    break;

                case 'disable_edit_dashboards':
                case 'disable_edit_dash_items':
                    item.checked = !this.workspace.app_functions.dashboards[item.key];
                    break;

                case 'disable_edit_reports':
                case 'disable_save_reports':
                case 'disable_csv_downloads':
                    item.checked = !this.workspace.app_functions.data_reports[item.key];
                    break;

                case 'disable_grouping_duplicate_datalinks':
                    item.checked = this.workspace.app_functions.data_reports[item.key];
                    break;

                case 'disable_db_settings':
                case 'disable_grid_view':
                case 'disable_borad_view':
                case 'disable_status_update':
                case 'disable_query':
                case 'disable_auto_link':
                    item.checked = !this.workspace.app_functions.datastores[item.key];
                    break;

                case 'disable_csv_update':
                case 'disable_replace_import':
                case 'use_qr_download':
                    item.checked = !this.workspace.app_functions.csv_import[item.key];
                    break;

                case 'disable_execute_bulk_action_script':
                    item.checked = this.workspace.app_functions.csv_import[item.key];
                    break;

                case 'disable_pagination':
                case 'disable_change_layouts':
                case 'disable_edit_statuses':
                case 'disable_edit_fields':
                case 'disable_edit_actions':
                case 'hide_link_items':
                case 'disable_pin_items':
                    item.checked = !this.workspace.app_functions.item_view[item.key];
                    break;
                case 'always_update_auto_link':
                    item.checked = this.workspace.app_functions.data_link[item.key];
                    break;
                case 'enable_strictly_validation':
                    item.checked = this.workspace.app_functions.item_operation[item.key];
                    break;
                case 'enable_remove_deleted_field':
                    item.checked = this.workspace.app_functions.item_operation[item.key];
                    break;
                case 'skip_access_control':
                    item.checked = this.workspace.app_functions.app_settings[item.key];
                    break;
            }
        });
    }

    changeWsAdmin() {
        var admins = [];
        this.whitelists.forEach((sv) => {
            sv.disabled = false;
        });

        this.workspace.admin_users.forEach((admin) => {
            if (!admin.is_sv) admins.push(admin.user_id);
        });

        if (admins.length == 0) {
            this.whitelists.forEach((sv) => {
                if (sv.checked) admins.push(sv.u_id);
            });

            if (admins.length <= 1) {
                this.whitelists.forEach((sv) => {
                    if (sv.checked) sv.disabled = true;
                });
            }
        }
    }

    saveChanges() {
        this.currentEditWorkspace = { ...this.currentEditWorkspace, ...this.rowSettingsForm.value };
        var params = <Workspace> {
            datastores: this.currentEditWorkspace['datastores_limit'],
            users_limit: this.currentEditWorkspace['users_limit'],
            storage_limit: this.currentEditWorkspace['storage_limit'],
            w_id: this.currentEditWorkspace['w_id'],
            items_limit: this.currentEditWorkspace['items_limit'],
        };

        this.parseCompletedFormat();
        var columnParams = {
            w_id: this.currentEditWorkspace['w_id'],
            ws_admin: [],
            ws_usages: params,
            ws_functions: this.workspace.ws_functions,
            app_functions: this.workspace.app_functions,
            keycloak_settings: this.workspace.keycloak_settings,
        };

        this.workspace.admin_users.forEach((user) => {
            if (!user.is_sv) columnParams.ws_admin.push(user.user_id);
        });

        this.whitelists.forEach((sv) => {
            if (sv.checked) columnParams.ws_admin.push(sv.u_id);
        });

        this._wsusageService.UpdateWorkspaceLimitsSettings(columnParams).subscribe(
            result => {
                this.loadData.emit();
            },
            err => {},
        );
    }

    parseCompletedFormat() {
        this.wsFunctions.map(item => {
            switch (item.key) {
                case 'disable_change_name':
                case 'disable_change_logo':
                case 'disable_manage_admins':
                case 'disable_archive':
                case 'disable_password_policy':
                case 'disable_global_search':
                    this.workspace.ws_functions.ws_settings[item.key] = !item.checked;
                    break;
                case 'enable_manage_group_admins':
                case 'enable_2fa_login':
                case 'enable_whitelist_url':
                    this.workspace.ws_functions.ws_settings[item.key] = item.checked;
                    break;
                case 'ease_setting_restrictions':
                    this.workspace.ws_functions.ws_settings[item.key] = item.checked;
                    break;
                case 'enable_field_role_validation':
                    this.workspace.ws_functions.ws_settings[item.key] = item.checked;
                    break;
                case 'enable_check_user_limit_flag':
                case 'enable_check_datastore_limit_flag':
                    this.workspace.ws_functions.ws_settings[item.key] = item.checked;
                    break;
                case 'enable_return_timeout_error':
                    this.workspace.ws_functions.ws_settings[item.key] = item.checked;
                    break;

                case 'disable_new_group':
                case 'disable_group_import':
                case 'disable_user_import':
                case 'disable_group_roles':
                    this.workspace.ws_functions.group_settings[item.key] = !item.checked;
                    break;
                case 'disable_get_user_list_for_non_admin':
                    this.workspace.ws_functions.group_settings[item.key] = item.checked;
                    break;
                case 'disable_get_role_users_for_non_admin':
                    this.workspace.ws_functions.group_settings[item.key] = item.checked;
                    break;
                case 'disable_developer_mode':
                case 'disable_beta':
                case 'disable_generate_token':
                    this.workspace.ws_functions.developer_functions[item.key] = !item.checked;
                    break;
                case 'show_access_keys':
                    this.workspace.ws_functions.developer_functions[item.key] = item.selected;
                    break;

                case 'show_task_list':
                    this.workspace.ws_functions.task_queue[item.key] = item.selected;
                    break;

                case 'new_workspace':
                    this.workspace.ws_functions.new_workspaces[item.key] = item.selected;
                    break;

                case 'number_bulk_registrations':
                    this.workspace.ws_functions.user_settings[item.key] = item.value;
                    break;
                case 'requests_per_seconds':
                    this.workspace.ws_functions.rate_limit[item.key] = item.value;
                    break;
                case 'validity_period_2fa':
                    this.workspace.ws_functions.ws_settings[item.key] = item.value;
                    break;
                case 'host':
                    this.workspace.keycloak_settings[item.key] = item.value;
                    break;
                case 'realms':
                    this.workspace.keycloak_settings[item.key] = item.value;
                    break;
            }
        });

        this.appFunctions.map(item => {
            switch (item.key) {
                case 'disable_change_name':
                case 'disable_role_settings':
                case 'disable_left_menu_extension':
                case 'disable_program_extension':
                case 'disable_delete_application':
                    this.workspace.app_functions.app_settings[item.key] = !item.checked;
                    break;
                case 'enable_action_validation':
                case 'enable_field_values_validation':
                case 'enable_upload_file_validation':
                    this.workspace.app_functions.app_settings[item.key] = item.checked;
                    break;
                case 'disable_new_application':
                case 'disable_save_templates':
                    this.workspace.app_functions.app_templates[item.key] = !item.checked;
                    break;

                case 'disable_edit_dashboards':
                case 'disable_edit_dash_items':
                    this.workspace.app_functions.dashboards[item.key] = !item.checked;
                    break;

                case 'disable_edit_reports':
                case 'disable_save_reports':
                case 'disable_csv_downloads':
                    this.workspace.app_functions.data_reports[item.key] = !item.checked;
                    break;

                case 'disable_grouping_duplicate_datalinks':
                    this.workspace.app_functions.data_reports[item.key] = item.checked;
                    break;

                case 'disable_db_settings':
                case 'disable_grid_view':
                case 'disable_borad_view':
                case 'disable_status_update':
                case 'disable_query':
                case 'disable_auto_link':
                    this.workspace.app_functions.datastores[item.key] = !item.checked;
                    break;

                case 'disable_csv_update':
                case 'disable_replace_import':
                case 'use_qr_download':
                    this.workspace.app_functions.csv_import[item.key] = !item.checked;
                    break;

                case 'disable_execute_bulk_action_script':
                    this.workspace.app_functions.csv_import[item.key] = item.checked;
                    break;

                case 'disable_pagination':
                case 'disable_change_layouts':
                case 'disable_edit_statuses':
                case 'disable_edit_fields':
                case 'disable_edit_actions':
                case 'hide_link_items':
                case 'disable_pin_items':
                    this.workspace.app_functions.item_view[item.key] = !item.checked;
                    break;
                case 'always_update_auto_link':
                    this.workspace.app_functions.data_link[item.key] = item.checked;
                    break;
                case 'enable_strictly_validation':
                    this.workspace.app_functions.item_operation[item.key] = item.checked;
                    break;
                case 'enable_remove_deleted_field':
                    this.workspace.app_functions.item_operation[item.key] = item.checked;
                    break;
                case 'skip_access_control':
                    this.workspace.app_functions.app_settings[item.key] = item.checked;
                    break;
            }
        });
    }

    cancelModal = () => {
        this.defaultSettingsModal = false;
    };

    getWsLimits() {
        this.defaultSettingsModal = !this.defaultSettingsModal;
        this._wsusageService.GetWsLimits<WsLimit>().subscribe(
            result => {
                let data = result;
                this.currentWsLimit = data;

                var cols = [];
                for (const key of this.wsLimitColumns) {
                    cols[key] = [this.currentWsLimit[key], [Validators.required]];
                }
                this.defaultSettingsForm = this.fb.group(cols);
            },
        );
    }

    showWorkspaceModal() {
        this.createWorkspaceModal = true;

        this._wsusageService.GetWorkspacePlans<any>().subscribe(
            result => {
                this.workspacePlans = result.workspaces_plans;
            },
            err => {},
        );
    }

    createWorkspace() {
        this._wsusageService.CreateWorkspaceForAdmin(this.createWorkspaceForm.value).subscribe(
            result => {
                this.createWorkspaceModal = false;
                // this.loadData();
                this.newWID.emit(result.w_id);
            },
            err => {},
        );
    }

    cancelWorkspaceModal = () => {
        this.createWorkspaceModal = false;
    };

    saveWsLimit() {
        this._fmt.log(this.currentWsLimit);
        this._wsusageService.PostSaveWsUsageDefaults(this.defaultSettingsForm.value).subscribe(
            result => {
                this.defaultSettingsModal = false;
            },
            err => {},
        );
    }

    addWhitelistRow() {
        console.debug(this.workspace);
        this.publicUrlWhitelists.unshift(
            <Object> {
                'id': this.publicUrlWhitelists && this.publicUrlWhitelists[0] ? this.publicUrlWhitelists[0]['id'] + 1 : 0,
                'u_id': this.workspace.admin_users ? this.workspace.admin_users[0]['user_id'] : '',
                'w_id': '',
                'url': '',
                'method': '',
            },
        );
    }
    addIPAddrWhitelistRow() {
        this.ipAddrLists.unshift(
            <Object> {
                'id': this.ipAddrLists && this.ipAddrLists[0] ? this.ipAddrLists[0]['id'] + 1 : 0,
                'w_id': '',
                'ip_addr': '',
            },
        );
    }

    editWhiteList(viewMode: string) {
        this.fetchURLWhitelists(this.workspace.w_id, () => {
            this.tableMode = viewMode;
        });
    }
    editIPAddrWhiteList(viewMode: string) {
        this.fetchIPAddrWhitelists(this.workspace.w_id, () => {
            this.tableModeIpAddr = viewMode;
        });
    }

    cancelEditWhitelist(viewMode: string) {
        this.fetchURLWhitelists(this.workspace.w_id, () => {
            this.tableMode = viewMode;
        });
    }
    cancelEditIPAddrWhitelist(viewMode: string) {
        this.fetchIPAddrWhitelists(this.workspace.w_id, () => {
            this.tableModeIpAddr = viewMode;
        });
    }

    savePublicUrlList(viewMode: string) {
        this.publicUrlWhitelists.forEach(url => url.w_id = this.workspace.w_id);
        this._wsusageService.PostUpdateURLWhitelist({ w_id: this.workspace.w_id, url_whitelists: this.publicUrlWhitelists }).subscribe(
            result => {
                this.tableMode = viewMode;
            },
            err => {
                console.log(err);
            },
        );
    }

    savePublicIPAddrWhiteList(viewMode: string) {
        this.ipAddrLists.forEach(url => url.w_id = this.workspace.w_id);
        this._wsusageService.PostUpdateIPAddrWhitelist({ w_id: this.workspace.w_id, ipaddr_whitelists: this.ipAddrLists }).subscribe(
            result => {
                this.tableModeIpAddr = viewMode;
            },
            err => {
                console.log(err);
            },
        );
    }

    tabCallback(event: any, workspace: any) {
        console.log(event);
        if (event.index == 4) this.fetchURLWhitelists(workspace.w_id, null);
    }

    fetchURLWhitelists(wsID: any, callback?: () => void) {
        if (!wsID || wsID == undefined) return;

        this.publicUrlWhitelists = [];
        this._wsusageService.GetURLWhitelists<any>({ w_id: wsID }).subscribe(
            result => {
                this.publicUrlWhitelists = result['url_whitelists'] || [];
                if (callback) callback();
            },
            err => {},
        );
    }

    fetchIPAddrWhitelists(wsID: any, callback?: () => void) {
        this.ipAddrLists = [];
        this._wsusageService.GetIPAddrWhitelists<any>({ w_id: wsID }).subscribe(
            result => {
                this.ipAddrLists = result['ipaddr_whitelists'] || [];
                this.wsEnableIpfilter = result['use_ip_filter'];
                if (callback) callback();
            },
            err => {
                console.log(err);
            },
        );
    }

    toggleWsIPFilter() {
        // this.wsEnableIpfilter = !this.wsEnableIpfilter;
        this._wsusageService.PostEnableWSIPFilter({ w_id: this.workspace.w_id, enable_ip_filter: this.wsEnableIpfilter }).subscribe(
            result => {
                console.log(result);
            },
            err => {
                console.log(err);
            },
        );
    }

    handleRowSettingsOnOK = (e: any) => {
        this.defaultRowSettingsModal = false;
        this.saveChanges();
    };

    handleRowSettingsOnCanc = (e: any) => {
        this.defaultRowSettingsModal = false;
    };

    deleteItemIpAddrLists = (item: any): any[] => this.ipAddrLists.splice(item, 1);
    deleteItemPublicUrlWhitelists = (item: any): any[] => this.publicUrlWhitelists.splice(item, 1);

    truncateStr = (str: string, ending: string = '....'): string => str.length > 300 ? str.substring(0, 100) + ending : str;

    deleteKeycloakSetting = (item: any): any[] => this.workspace.keycloak_settings.realms.splice(item, 1);
    addKeycloakSetting = () => {
        this.workspace.keycloak_settings.realms.push(
            {
                realm: '',
                username: '',
                password: '',
            },
        );
    };

    fetchProjectList(wsID: any, callback?: () => void) {
        this._wsusageService.GetProjectLists<any>({ w_id: wsID }).subscribe(
            result => {
                this.projectLists = result;
                if (callback) callback();
            },
            err => {
                console.log(err);
            },
        );
    }

    selectProjectForCMSMode(value: string | null) {
        this.projectObj = value;
        if (value) {
            const target = this.projectLists.filter(v => v.p_id == value);
            if (target.length == 1) {
                this.cmsOption.forEach(v => v.checked = target[0].use_cms_mode);
            }
        }
    }

    changeCMSMode(model: { label: string; value: boolean; checked: boolean }[]) {
        this._wsusageService.PostUpdateProjectMode({
            p_id: this.projectObj,
            use_cms_mode: model[0].checked,
        })
            .subscribe(
                result => {
                    this.fetchProjectList(this.workspace.w_id);
                    console.log(result);
                },
                err => {
                    console.log(err);
                },
            );
    }
}

export interface TableColumn {
    name: string;
    key: string;
    editable: boolean;
    status?: boolean;
}

export interface FunctionsCheckBox {
    name: string;
    key: string;
    checked?: boolean;
    selected?: number;
    level: number;
    type?: string;
    value?: string | number | [];
    nzSpan?: number;
    note?: string;
}

export interface FunctionsCheckBoxSelect {
    name: string;
    id: number;
}
